import { render } from "./AdsPage.vue?vue&type=template&id=f29652c6&ts=true"
import script from "./AdsPage.vue?vue&type=script&lang=ts"
export * from "./AdsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__